import {RegistroFuncionalidad, useAuth, UserModel} from '../../auth'

export function formatDate(fecha: string) {
  const date = new Date(fecha)
  const day = String(date.getUTCDate()).padStart(2, '0')
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const year = date.getUTCFullYear()
  const hours = String(date.getUTCHours()).padStart(2, '0')
  const minutes = String(date.getUTCMinutes()).padStart(2, '0')
  return `${day}/${month}/${year} ${hours}:${minutes}`


}

export function convertirFechaHora(fechaEntrega: string, horaEntrega: string) {
  const [time, modifier] = horaEntrega.split(' ')
  let [hours, minutes] = time.split(':').map(Number)

  if (modifier === 'PM' && hours !== 12) {
    hours += 12
  }
  
  else if (modifier === 'AM' && hours === 12) {
    hours = 0
  }
  
  const date = new Date(
    `${fechaEntrega}T${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`
  )

  const year = date.getFullYear()
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0')
  const formattedHours = date.getHours().toString().padStart(2, '0')
  const formattedMinutes = date.getMinutes().toString().padStart(2, '0')
  const seconds = date.getSeconds().toString().padStart(2, '0')
  const milliseconds = date.getMilliseconds().toString().padStart(3, '0')
  
  return `${year}-${month}-${day}T${formattedHours}:${formattedMinutes}:${seconds}.${milliseconds}Z`
}

export function formatTo12Hour(timeString: string) {
  const date = new Date(timeString)
  let hours = date.getUTCHours()
  const minutes = date.getUTCMinutes()
  const ampm = hours >= 12 ? 'PM' : 'AM'

  hours = hours % 12
  hours = hours ? hours : 12 // El 0 debe ser 12
  const minutesStr = minutes < 10 ? '0' + minutes : minutes

  return hours + ':' + minutesStr + ' ' + ampm
}

export function DateFormat(isoString: string): string {
  const date = new Date(isoString)
  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const day = String(date.getUTCDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function convertToISODateString(dateString:string) {
  const date = new Date(dateString) 
  console.log(typeof(Intl.DateTimeFormat().resolvedOptions().timeZone))
return date.toISOString();
}

export const getNodoByNivel = (
  idMenu: number,
  nivel: number,
  currentUser: UserModel | undefined
): RegistroFuncionalidad | null => {
  if (!currentUser?.registro?.funcionalidad) {
    return null;
  }

  const data: RegistroFuncionalidad[] = currentUser.registro.funcionalidad;
  // Buscar el nodo raíz
  const nodoRaiz = data.find(
    (funcionalidad) =>
      funcionalidad.menu.IdMenu === idMenu &&
      funcionalidad.accesoPadre === null
  );

  if (!nodoRaiz) {
    // console.error(`No se encontró el nodo raíz con IdMenu ${idMenu}.`);
    return null;
  }

  // Función para buscar en el nivel deseado dentro del nodo raíz
  const findNodoByNivel = (
    nodo: RegistroFuncionalidad,
    nivelActual: number
  ): RegistroFuncionalidad | null => {
    
    if (nivelActual === 0) {
      return nodo; // Si el nivel actual es 0, devolver el nodo actual
    }

    for (const hijo of nodo.accesohijo) {
      const resultado = findNodoByNivel(hijo, nivelActual - 1);
      if (resultado) {
        return resultado;
      }
    }

    return null; // Si no se encuentra ningún nodo en el nivel, devolver null
  };

  // Buscar el nodo en el nivel deseado dentro del nodo raíz
  return findNodoByNivel(nodoRaiz, nivel);
};

export const buscarPorIdMenu = (
  funcionalidad: RegistroFuncionalidad | null,
  idMenu: number
): RegistroFuncionalidad | null => {
  // Si el IdMenu actual coincide, devuelve la funcionalidad actual
  if (funcionalidad?.menu.IdMenu === idMenu) {
    return funcionalidad;
  }
  // Buscar recursivamente en los hijo
  if(funcionalidad){
    for (const hijo of funcionalidad.accesohijo) {
      const resultado = buscarPorIdMenu(hijo, idMenu);
      if (resultado) {
        return resultado;
      }
    }
  }
  // Si no encuentra nada, devuelve null
  return null;
};
export const truncateText = (text: string, maxLength: number = 24): string => {
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text
}
